<template>
    <div class="hello">
        <el-dropdown trigger="click">
            <el-button plain type="text" class="icon">
        Hello,{{user_info.user_name}}
                <!-- <i class="el-icon-setting icon"></i> -->
            </el-button>
            <el-dropdown-menu slot="dropdown" >
                <el-dropdown-item @click.native="edit()">Edit Info</el-dropdown-item>
                <el-dropdown-item @click.native="()=>showAuth=true" v-if="user_info.group_name == 'admin'">Auth Management</el-dropdown-item>
                <el-dropdown-item @click.native="loginOut()">Login Out</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>

		<el-dialog :visible.sync="showAuth">
			<span slot="title">Auth</span>
			<el-form label-width="200px" class="edit-camp">
				<el-form-item label="Adveriter" >
                    <mm-adv-select v-model="auth.adv_ids" multiple />
				</el-form-item>
				<el-form-item label="Channel" >
                    <mm-channel-select v-model="auth.channel_ids" multiple />
				</el-form-item>
				<el-form-item label="Type" >
                    <el-radio-group v-model="options.type">
                        <el-radio label='add'>add</el-radio>
                        <el-radio label='del'>del</el-radio>
                    </el-radio-group>
				</el-form-item>
				<el-form-item label="User" >
			        <mm-users v-model="options.user_name"></mm-users>
				</el-form-item>
		        <el-button type="primary" style="margin-left:150px;" @click='updateAuth()'>Save</el-button>
			</el-form>

		</el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        const user_info = this.$utils.getCookies(['user_name','user_id','user_email','group_name']);
        return {
            user_info:user_info,
            showAuth: false,
            options: {
                authority: {
                    adv_ids: [],
                    channel_ids: [],
                },
                type: 'add',
                user_name: '',
            },
            auth: {
                adv_ids: {},
                channel_ids: {},
            }
        }
    },
    methods: {
        edit() {
			this.$router.push({ path: "/userEdit",query:{id:this.user_info.user_id} });
        },
        async loginOut() {
            this.$utils.clearAllCookie();
            await this.$post('/user/loginOut');
			this.$router.push({ path: "/login" });
        },
        async updateAuth() {
            // console.log(this.options);
            if ((!!this.auth.adv_ids
            && !this.auth.adv_ids.$in
            && !this.auth.adv_ids.$in.length
            && !this.auth.channel_ids
            && !this.auth.channel_ids.$in
            && !this.auth.channel_ids.$in.length)
            || !this.options.user_name) {
                this.$message({
                    message: 'Missing Missing parameter',
                    type: 'error'
                });
                return;
            }
            this.options.authority.adv_ids = this.auth.adv_ids.$in || [];
            this.options.authority.channel_ids = this.auth.channel_ids.$in || [];
            // console.log(this.options);
            await this.$post('/user/auth', this.options);
        }
    }

}
</script>

<style scoped>
.hello {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #020202;
}
.icon {
    color: #020202;
    font-size: 15px;
}
</style>